import {rpc} from './session';
import _ from 'lodash';

export async function routing(points) {
    return await rpc.request('com.rnis.geo.action.service.routing', {points});
}

export async function getClosestStopPoint(latitude, longitude) {
    return await rpc.request('com.rnis.geo.action.stop_point.closest.get', {latitude, longitude});
}

export async function geocode(q, bounding_box, zoom) {
    return await rpc.request('com.rnis.geo.action.service.geocoding', {q, bounding_box, zoom});
}

export async function searchAddress(q, bounding_box, zoom) {
    return await rpc.request(window.RNIS_SETTINGS.isNSO ? 'com.rnis.geo.action.stop_point.geocoding.search' : 'com.rnis.geo.action.service.geocoding.search', {q, bounding_box, zoom});
}

export async function reverseGeocode(coordinates, bounding_box, zoom) {
    return await rpc.request('com.rnis.geo.action.service.geocoding', {coordinates, bounding_box, zoom});
}

export async function listLayers() {
    return await rpc.request('com.rnis.geo.action.layer.list', {}, {
        meta: {
            filters: {
                onlyVisible: true,
            },
        },
    });
}

export async function listUserGeoObjectsByLayers(layers) {
    return await rpc.request('com.rnis.geo.action.user_geo_object.list_by_layers', layers);
}

export async function listUserGeoObjectsMO(meta) {
    return await rpc.request('com.rnis.geo.action.user_geo_object.mo', {},{meta});
}

export async function getStopPoints(meta) {
    if (_.get(meta, 'filters.withZoom', 20) <= 13) {
        return {
            isOk: true,
            payload: {
                items: [],
            },
        };
    }
    return await rpc.request('com.rnis.geo.action.stop_point.list', {}, {meta});
}

export async function getStopPointRoutes(uuid, time = null) {
    return await rpc.request('com.rnis.geo.action.stop_point.routes', {uuid, time});
}

export async function getStopPointRouteRuns(uuid, routeUuid, time = null, onlyFirst = false, page = 1) {
    return await rpc.request('com.rnis.geo.action.stop_point.route.runs', {
        uuid,
        route_uuid: routeUuid,
        time,
        only_first: onlyFirst,
        page,
    });
}

export async function portalSchedule(number, date) {
    return await rpc.request('com.rnis.geo.action.portal_schedule', {number, date});
}

export async function portalScheduleExtended(number, date, from, to) {
    return await rpc.request('com.rnis.geo.action.portal_schedule', {number, date, from, to});
}

export async function portalScheduleRoute(orderRunUuid) {
    return await rpc.request('com.rnis.geo.action.portal_schedule.route', {
        order_run_uuid: orderRunUuid,
    });
}



// WEBPACK FOOTER //
// ./src/helpers/api/geo.js